/**
 * i18n Configuration — CRITICAL #2 (WCAG 3.1.1 A)
 *
 * Sets up react-i18next with:
 * - English (en) as default
 * - Spanish (es) as second locale
 * - Browser language auto-detection
 * - Dynamic <html lang=""> attribute updates
 *
 * TODO: Add Arabic (ar) and Vietnamese (vi) translations
 * when professional translations are available.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      // TODO: Add Arabic (ar) and Vietnamese (vi) when translations are ready
      // ar: { translation: ar },
      // vi: { translation: vi },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],

    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'followup_language',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    react: {
      useSuspense: false, // Prevent Suspense boundaries for progressive loading
    },
  });

// Update <html lang=""> when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
  // Set dir for RTL languages (future Arabic support)
  document.documentElement.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr');
});

// Set initial lang attribute
document.documentElement.setAttribute('lang', i18n.language || 'en');

export default i18n;
